// extracted by mini-css-extract-plugin
export default {"demo_profile":"DemoProfile_demo_profile__sOSl7","swiper":"DemoProfile_swiper__rsmVH","image_container":"DemoProfile_image_container__PzZZU"};